module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_7042.ba54d71d.png";